import React from 'react';
import './TokenTable.css';

const TokenTable = ({ activeTab }) => {
  const liveTokens = [
    {
      symbol: '2Z',
      name: 'DoubleZero',
      iconBg: '#3b82f6',
      iconText: '2Z',
      lastPrice: 0.55,
      priceChange: '+315.7%',
      vol24h: '1,406,983',
      vol24hChange: '+2,521.2%',
      totalVol: '1,606,884',
      totalVolChange: '+703.8%',
      settleStarts: '02/10/2025\n01:00 PM',
      settleEnds: '02/10/2025\n05:00 PM'
    },
    {
      symbol: 'YB',
      name: 'Yield Basis',
      iconBg: '#1e40af',
      iconText: 'YB',
      lastPrice: 0.85,
      priceChange: '+83.6%',
      vol24h: '1,246,837',
      vol24hChange: '+17,608%',
      totalVol: '1,263,097',
      totalVolChange: '+7,668.2%',
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'SUP',
      name: 'Superfluid',
      iconBg: '#22c55e',
      iconText: 'SUP',
      lastPrice: 0.22,
      priceChange: '0%',
      vol24h: '3,774.8',
      vol24hChange: '-44.163%',
      totalVol: '22,613',
      totalVolChange: '+20%',
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'OFC',
      name: 'OneFootball Club',
      iconBg: '#64748b',
      iconText: 'OFC',
      lastPrice: 0.28,
      priceChange: '0%',
      vol24h: '3,213.3',
      vol24hChange: '-47.158%',
      totalVol: '24,387',
      totalVolChange: '+15.2%',
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'ZBT',
      name: 'ZeroBase',
      iconBg: '#0ea5e9',
      iconText: 'ZBT',
      lastPrice: 0.00001,
      priceChange: '0%',
      vol24h: '2,009.1',
      vol24hChange: '+33.9%',
      totalVol: '3,509.1',
      totalVolChange: '+133.9%',
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'MMT',
      name: 'Momentum',
      iconBg: '#3b82f6',
      iconText: 'MMT',
      lastPrice: 0.64,
      priceChange: '0%',
      vol24h: '1,000',
      vol24hChange: '0%',
      totalVol: '20,877',
      totalVolChange: '+5.03%',
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'LMTS',
      name: 'Limitless',
      iconBg: '#6366f1',
      iconText: 'LMTS',
      lastPrice: 0,
      priceChange: '0%',
      vol24h: '950',
      vol24hChange: '+533.3%',
      totalVol: '950',
      totalVolChange: '0%',
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'Enso',
      name: 'Enso',
      iconBg: '#8b5cf6',
      iconText: 'Enso',
      lastPrice: 9,
      priceChange: '0%',
      vol24h: '57',
      vol24hChange: '0%',
      totalVol: '15,187',
      totalVolChange: '+0.38%',
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    }
  ];

  const upcomingTokens = [
    {
      symbol: 'Base',
      name: 'Base',
      iconBg: '#0052ff',
      iconText: 'B',
      watchers: 12450,
      totalFundRaise: '$250M',
      investors: [
        { name: 'Coinbase Ventures', logo: 'CB' },
        { name: 'a16z crypto', logo: 'A16Z' },
        { name: 'Paradigm', logo: 'P' },
        { name: 'Haun Ventures', logo: 'HV' }
      ],
      narrative: { category: 'L2s', color: '#3b82f6' },
      moniScore: 18500,
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'Mon',
      name: 'Monad',
      iconBg: '#6366f1',
      iconText: 'M',
      watchers: 8920,
      totalFundRaise: '$225M',
      investors: [
        { name: 'Dragonfly Capital', logo: 'DF' },
        { name: 'Placeholder', logo: 'PH' },
        { name: 'Electric Capital', logo: 'EC' },
        { name: 'Cobie', logo: 'C' },
        { name: 'Naval Ravikant', logo: 'NR' }
      ],
      narrative: { category: 'L1', color: '#8b5cf6' },
      moniScore: 20994,
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'MASK',
      name: 'MetaMask',
      iconBg: '#f6851b',
      iconText: 'M',
      watchers: 15600,
      totalFundRaise: '$450M',
      investors: [
        { name: 'ConsenSys', logo: 'CS' },
        { name: 'Andreessen Horowitz', logo: 'A16Z' },
        { name: 'Tiger Global', logo: 'TG' }
      ],
      narrative: { category: 'Crypto Wallet', color: '#f59e0b' },
      moniScore: 16750,
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'RNBW',
      name: 'Rainbow',
      iconBg: '#ff6b6b',
      iconText: 'R',
      watchers: 7340,
      totalFundRaise: '$18M',
      investors: [
        { name: 'Coinbase Ventures', logo: 'CB' },
        { name: 'Variant Fund', logo: 'VF' },
        { name: 'Chapter One', logo: 'C1' },
        { name: 'Sfermion', logo: 'SF' }
      ],
      narrative: { category: 'Crypto Wallet', color: '#f59e0b' },
      moniScore: 14200,
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    },
    {
      symbol: 'MET',
      name: 'Meteora',
      iconBg: '#22c55e',
      iconText: 'M',
      watchers: 5890,
      totalFundRaise: '$4M',
      investors: [
        { name: 'Multicoin Capital', logo: 'MC' },
        { name: 'Solana Ventures', logo: 'SV' },
        { name: 'Jump Crypto', logo: 'JC' }
      ],
      narrative: { category: 'DEXes', color: '#22c55e' },
      moniScore: 11800,
      settleStarts: 'TBA',
      settleEnds: 'TBA'
    }
  ];

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  const formatChange = (change) => {
    if (change === '-') {
      return <span className="neutral">{change}</span>;
    } else if (change.startsWith('+')) {
      return <span className="positive">{change}</span>;
    } else if (change.startsWith('-')) {
      return <span className="negative">{change}</span>;
    } else {
      return <span className="neutral">{change}</span>;
    }
  };

  const endedTokens = [
    {
      symbol: 'WLFI',
      name: 'World Liberty Financial',
      iconBg: '#3b82f6',
      iconText: 'W',
      lastPrice: 0.37,
      totalVol: '55,202,865',
      settleStarts: '01/09/2025',
      settleEnds: '01/09/2025'
    },
    {
      symbol: 'JUP',
      name: 'Jupiter',
      iconBg: '#22c55e',
      iconText: 'J',
      lastPrice: 0.68,
      totalVol: '43,535,431',
      settleStarts: '31/01/2024',
      settleEnds: '01/02/2024'
    },
    {
      symbol: 'ME',
      name: 'MagicEden',
      iconBg: '#8b5cf6',
      iconText: 'ME',
      lastPrice: 5.82,
      totalVol: '17,795,237',
      settleStarts: '10/12/2024',
      settleEnds: '11/12/2024'
    },
    {
      symbol: 'XPL',
      name: 'Plasma',
      iconBg: '#f59e0b',
      iconText: 'XPL',
      lastPrice: 0.85,
      totalVol: '11,397,367',
      settleStarts: '25/09/2025',
      settleEnds: '26/09/2025'
    },
    {
      symbol: 'PENGU',
      name: 'Pudgy Penguins',
      iconBg: '#64748b',
      iconText: 'P',
      lastPrice: 0.0464,
      totalVol: '7,483,875',
      settleStarts: '17/12/2024',
      settleEnds: '18/12/2024'
    },
    {
      symbol: 'PORTAL',
      name: 'Portal',
      iconBg: '#0ea5e9',
      iconText: 'P',
      lastPrice: 3.08,
      totalVol: '6,735,887',
      settleStarts: '29/02/2024',
      settleEnds: '01/03/2024'
    },
    {
      symbol: 'IO',
      name: 'io.net',
      iconBg: '#6366f1',
      iconText: 'IO',
      lastPrice: 3.5,
      totalVol: '6,634,585',
      settleStarts: '11/06/2024',
      settleEnds: '12/06/2024'
    }
  ];

  const tokens = activeTab === 'Live' ? liveTokens : activeTab === 'Ended' ? endedTokens : upcomingTokens;

  const InvestorsIcons = ({ investors }) => {
    return (
      <div className="investors-container">
        {investors.map((investor, index) => (
          <div 
            key={index} 
            className="investor-icon" 
            data-tooltip={investor.name}
            style={{ zIndex: investors.length - index }}
          >
            {investor.logo}
          </div>
        ))}
      </div>
    );
  };

  const NarrativeTag = ({ narrative }) => {
    const hexToRgba = (hex, alpha) => {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    return (
      <span 
        className="narrative-tag" 
        style={{ 
          borderColor: narrative.color,
          backgroundColor: hexToRgba(narrative.color, 0.3),
          color: narrative.color
        }}
      >
        {narrative.category}
      </span>
    );
  };

  const MoniScore = ({ score }) => {
    const maxScore = 25000;
    const percentage = (score / maxScore) * 100;
    
    return (
      <div className="moni-score-container">
        <div className="moni-score-value">{formatNumber(score)}</div>
        <div className="moni-score-bar">
          <div className="moni-score-track">
            <div 
              className="moni-score-fill" 
              style={{ width: `${percentage}%` }}
            ></div>
            <div 
              className="moni-score-indicator" 
              style={{ left: `${percentage}%` }}
            ></div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="token-table-container">
      <div className="table-wrapper">
        <table className="token-table">
          <thead>
            <tr>
              <th>Token</th>
              {activeTab === 'Live' ? (
                <>
                  <th>Last Price ($) ↕</th>
                  <th>24h Vol. ($) ↕</th>
                  <th>Total Vol. ($) ↕</th>
                  <th>Settle Starts (UTC)</th>
                  <th>Settle Ends (UTC)</th>
                </>
              ) : activeTab === 'Ended' ? (
                <>
                  <th>Last Price ($) ↕</th>
                  <th>Total Vol. ($) ↕</th>
                  <th>Settle Starts (UTC)</th>
                  <th>Settle Ends (UTC)</th>
                </>
              ) : (
                <>
                  <th>Watchers ↕</th>
                  <th>Total Fund Raise ↕</th>
                  <th>Investors & Backers</th>
                  <th>Narrative</th>
                  <th>Moni Score ↕</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {tokens.map((token, index) => (
              <tr key={index} className="token-row">
                <td className="token-cell">
                  <div className="token-info">
                    <div className="token-icon" style={{ backgroundColor: token.iconBg }}>
                      {token.iconText}
                    </div>
                    <div className="token-details">
                      <div className="token-symbol">{token.symbol}</div>
                      <div className="token-name">{token.name}</div>
                    </div>
                  </div>
                </td>
                {activeTab === 'Live' ? (
                  <>
                    <td className="price-cell">
                      <div className="price-info">
                        <div className="price">{token.lastPrice}</div>
                        <div className="price-change">{formatChange(token.priceChange)}</div>
                      </div>
                    </td>
                    <td className="volume-cell">
                      <div className="volume-info">
                        <div className="volume">{token.vol24h}</div>
                        <div className="volume-change">{formatChange(token.vol24hChange)}</div>
                      </div>
                    </td>
                    <td className="volume-cell">
                      <div className="volume-info">
                        <div className="volume">{token.totalVol}</div>
                        <div className="volume-change">{formatChange(token.totalVolChange)}</div>
                      </div>
                    </td>
                    <td className="settle-cell">
                      <div className="settle-time">{token.settleStarts}</div>
                    </td>
                    <td className="settle-cell">
                      <div className="settle-time">{token.settleEnds}</div>
                    </td>
                  </>
                ) : activeTab === 'Ended' ? (
                  <>
                    <td className="price-cell">
                      <div className="price">{token.lastPrice}</div>
                    </td>
                    <td className="volume-cell">
                      <div className="volume">{token.totalVol}</div>
                    </td>
                    <td className="settle-cell">
                      <div className="settle-time">{token.settleStarts}</div>
                    </td>
                    <td className="settle-cell">
                      <div className="settle-time">{token.settleEnds}</div>
                    </td>
                  </>
                ) : (
                  <>
                    <td className="watchers-cell">
                      <div className="watchers-count">{formatNumber(token.watchers)}</div>
                    </td>
                    <td className="fund-raise-cell">
                      <div className="fund-raise-amount">{token.totalFundRaise}</div>
                    </td>
                    <td className="investors-cell">
                      <InvestorsIcons investors={token.investors} />
                    </td>
                    <td className="narrative-cell">
                      <NarrativeTag narrative={token.narrative} />
                    </td>
                    <td className="moni-score-cell">
                      <MoniScore score={token.moniScore} />
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TokenTable;
